import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const HighRiskIcon: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 24 24" {...props}>
    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" />
    <g>
      <rect x="2" y="2" width="20" height="20" rx="10" fill="white" />
      <path d="M12.8335 16.1668L11.1668 16.1668L11.1668 14.5002L12.8335 14.5002V16.1668ZM12.8335 12.8335L11.1668 12.8335L11.1668 7.8335H12.8335L12.8335 12.8335ZM12.0002 20.3335C16.6002 20.3335 20.3335 16.6002 20.3335 12.0002C20.3335 7.40016 16.6002 3.66683 12.0002 3.66683C7.40016 3.66683 3.66683 7.40016 3.66683 12.0002C3.66683 16.6002 7.40016 20.3335 12.0002 20.3335Z" />
    </g>
  </BlueprintIcon>
);
